import {
  Accordions,
  CompareHeader,
  ExpandCollapse,
  CompareHeaderMobile,
} from "../components/Compare";
import { IFullPlanDetail, IFullPlanDetailPPO } from "../interfaces/api";
import { useState } from "react";
import BackNav from "../components/Compare/BackNav.component";
import { AllPlansFooterRecommen } from "../components/Reccomend";
import ScrollToTopOnRouteChange from "../shared/ScrollToTop.function";
import { useUpdateBreadcrumbs } from "../shared/updateBreadcrumbs.hook";
import { useLoaderData } from "react-router-dom";

const ComparePage = () => {
  useUpdateBreadcrumbs("See All Plans");

  const { plans: compareData } = useLoaderData() as {
    plans: IFullPlanDetail[] | IFullPlanDetailPPO[];
  };

  const [allAccordionsOpen, setAllAccordionsOpen] = useState<boolean>(false);
  const [anyAccordionOpen, setAnyAccordionOpen] = useState<boolean>(false);
  const [highlightDifferences, setHighlightDifferences] =
    useState<boolean>(false);
  const [activePlan, setActivePlan] = useState<number>(0);
  const storageData = sessionStorage.getItem("dataArray");

  const parsedData = storageData ? JSON.parse(storageData) : [];
  const dataArray: string[] = Object.values(parsedData);

  if (dataArray.length < 1) {
    return null;
  }
  while (dataArray.length < 3) {
    dataArray.push("");
  }

  const scrollTo = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const toggleAllAccordions = (isOpen: boolean) => {
    setAllAccordionsOpen(isOpen);
  };
  const handleDifference = (isDifference: boolean) => {
    setHighlightDifferences(isDifference);
  };

  if (compareData.length < 1) {
    return null;
  }

  return (
    <div>
      <ScrollToTopOnRouteChange />
      <BackNav plan={compareData[0].PlanDetails[0]} />
      <div className="grid-container">
        <CompareHeader plans={compareData} />
        <CompareHeaderMobile
          plans={compareData}
          setActivePlan={setActivePlan}
          activePlan={activePlan}
        />
        <ExpandCollapse
          toggleAllAccordions={toggleAllAccordions}
          allAccordionsOpen={allAccordionsOpen}
          anyAccordionOpen={anyAccordionOpen}
          highlightDifferences={highlightDifferences}
          setHighlightDifferences={handleDifference}
        />
        <Accordions
          data={compareData}
          allAccordionsOpen={allAccordionsOpen}
          setAnyAccordionOpen={setAnyAccordionOpen}
          highlightDifferences={highlightDifferences}
          activePlan={activePlan}
        />
        <AllPlansFooterRecommen plans={compareData} />

        <div className="grid-y show-for-small-only" style={{ width: "100%" }}>
          <p style={{ display: "flex", justifyContent: "center" }}>
            <button
              type="button"
              className="color-primary text-underline"
              style={{
                fontSize: "25px",
                padding: "24px 0px",
                fontWeight: 500,
                cursor: "pointer",
              }}
            >
              View Details
            </button>
          </p>
          <button
            type="button"
            className="button"
            style={{
              flex: 1,
              minHeight: "55px",
              fontWeight: 500,
              width: "100%",
            }}
            onClick={(e: React.MouseEvent<HTMLButtonElement>) =>
              e.preventDefault()
            }
          >
            Enroll
          </button>
        </div>

        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
          }}
        >
          <button
            type="button"
            onClick={scrollTo}
            className="primary-color"
            style={{
              cursor: "pointer",
              fontSize: 18,
              fontWeight: 500,
              paddingBottom: 24,
              paddingTop: 24,
            }}
          >
            ^ Back to top
          </button>
        </div>
      </div>
    </div>
  );
};

export default ComparePage;
